<template>
  <div class="d-flex">
    <div
      class="d-flex justify-content-center align-items-center mx-2 drag-handle pointer"
    >
      <font-awesome-icon :icon="['far', 'bars']" />
    </div>
    <div class="bio-edit-link-content">
      <!-- Mobile -->
      <div class="d-flex d-md-none align-items-center">
        <div class="mr-2">
          <div
            class="link-imag-container"
            v-if="link.image"
            @click="$emit('editLink', link)"
          >
            <img class="link-image" :src="link.image.thumbnail_storage" />
            <i class="far fa-pencil link-image-icon" />
          </div>
          <div class="link-image-add" v-else @click="$emit('editLink', link)">
            <i class="far fa-image c-brand-color"></i>
          </div>
        </div>
        <HMTextInput
          class="w-100 mb-0"
          v-model="link.label"
          @changedOnBlur="$emit('saveLink', link)"
        ></HMTextInput>
      </div>
      <div class="d-md-none my-2">
        <HMTextInput
          class="m-0"
          v-model="link.link"
          @changedOnBlur="$emit('saveLink', link)"
        ></HMTextInput>
      </div>
      <div class="d-flex d-md-none justify-content-between align-items-center">
        <HMSwitch v-model="link.active" @change="$emit('saveLink', link)" />
        <i
          class="far fa-trash-alt p-2 pointer"
          @click="$emit('deleteLink', link.id)"
        ></i>
      </div>
      <!-- Desktop -->
      <div class="d-none d-md-flex align-items-center w-100">
        <div class="mr-3">
          <div
            class="link-imag-container"
            v-if="link.image"
            @click="$emit('editLink', link)"
          >
            <img class="link-image" :src="link.image.thumbnail_storage" />
            <i class="far fa-pencil link-image-icon" />
          </div>
          <div
            class="link-image-add m-0"
            v-else
            @click="$emit('editLink', link)"
          >
            <i class="far fa-image c-brand-color"></i>
          </div>
        </div>
        <HMTextInput
          class="m-0 label-desktop"
          placeholder="Label"
          v-model="link.label"
          @changedOnBlur="$emit('saveLink', link)"
        ></HMTextInput>
        <HMTextInput
          placeholder="Link"
          class="m-0 w-100 ml-3"
          v-model="link.link"
          rules="url"
          @changedOnBlur="$emit('saveLink', link)"
        ></HMTextInput>
        <HMSwitch
          class="ml-3"
          v-model="link.active"
          @change="$emit('saveLink', link)"
        />
        <i
          class="far fa-trash-alt px-3 py-2 pointer"
          @click="$emit('deleteLink', link.id)"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'BioEditLink',
  props: {
    link: {
      type: Object,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

::v-deep .hm-file-upload-inner-container {
  width: 100%;
}

.bio-edit-link-content {
  display: flex;
  flex-direction: column;
  border: 1px solid $medium-gray;
  border-radius: 6px;
  padding: 0.5rem;
  width: 100%;
  @include media-breakpoint-up(md) {
    padding: 1rem;
    flex-direction: row;
    align-items: flex-end;
  }
}

.label-desktop {
  width: 250px;
}

.link-group {
  border: 1px solid $light-gray;
  border-radius: $border-radius;
}

.link-imag-container {
  position: relative;
  height: 42px;
  width: 42px;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
}

.link-image-add {
  width: 42px;
  text-align: center;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $medium-gray;
  border-radius: 6px;
  cursor: pointer;
}

.link-image-icon {
  display: none;
  color: white;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  justify-content: center;
  align-items: center;
}

.link-imag-container:hover .link-image-icon {
  display: flex;
}

.link-image {
  border-radius: 50%;
  height: 42px;
  width: 42px;
  object-fit: cover;
}
</style>
